module.exports = __webpack_public_path__ + "img/postgre-logo.8875ebb5.svg";